import React, {Component} from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {CenterEmpty, CenterLoading} from "../functions";
import Card from "@mui/material/Card";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import {
    AddCircleOutline,
    ArrowBack, CheckCircle, CheckCircleOutline,
    CommentOutlined,
    DeleteOutline,
    MoreVertOutlined,
    RemoveCircle,
    SendOutlined,
    TagOutlined,
} from "@mui/icons-material";
import {
    AppBar,
    Avatar,
    Button,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader,
    CardMedia,
    Chip,
    CircularProgress,
    Dialog,
    Fade,
    FormControl,
    FormControlLabel,
    IconButton,
    InputLabel,
    ListItem,
    ListItemAvatar,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    OutlinedInput,
    Paper,
    Stack,
    styled,
    Switch, Toolbar,
    Tooltip
} from "@mui/material";
import BottomSheet from "../../src/bottom_sheet_mui/src/components/BottomSheet/BottomSheet";
import Backdrop from "@mui/material/Backdrop";
import $ from "jquery";
import GifLoader from "../GifLoader";
const ListItemNew = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
}));
styled('paper')(({theme}) => ({
    position: "absolute",
    left: 0,
    bottom: 0
}));

export default class Community extends Component {

    componentDidMount() {
        window.community = this;
        window.home.setState({
           post:true
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            showed: 0,
            loading: true,
            data: [],
            story: [],
            error: false,
            postItem: {
                post: "",
                hasFire: false,
                hasAnime: false,
                hasImage: "",
                anime: [],
                youtube: "",
                userAddress: localStorage.getItem("deviceId")
            },
            postStory: {
                post: "",
                hasImage: "",
                userAddress: localStorage.getItem("deviceId")
            },
            addPost: false,
            comment: false,
            commentData: [],
            commentLoading: true,
            commentString: "",
            postComment: {
                post: "",
                id: ""
            },
            userData: {
                userimage: "",
                userId: "",
                admin: false
            },
            anchorEl: null,
            menuOpen: false,
            menuId: "",
            idForAdd: "",
            idForAddOpen: false,
            idForOpened: false,
            animeList: [],
            backdrop: false,
            menuPost: false,
            bottomStory: false,
            storyDataDialog: false,
            storyData: {
                image: "",
                time: "",
                user: "",
                text: "",
                hasPremium: "0",
                userimage: ""
            },
            bannedList: ""
        };
        this.prepare();
    }
    epMenuClose = () => {
        this.setState({
            menuPost: false
        });
    }
    epMenuOpen = () => {
        this.openAdd();
    }

    showFull = () => {
        let showed = this.state.showed;
        if (showed >= 3) {
            if (!window.main.checkLoggedAndPremium()) {
                if (window.main.ios()) {
                    window.webkit.messageHandlers.callback.postMessage(JSON.stringify({
                        "type": "shad"
                    }));
                }
            }
            this.setState({
                showed: 0
            });
        } else {
            showed++;
            this.setState({
                showed: showed
            });
        }
    }
    openIdForOpened = () => {
        this.setState({
            idForOpened: false,
            animeList: [],
            backdrop: true,
            idForAddOpen: false,
        });
        fetch('https://app.sanime.net/function/h10.php?name=search&name='+this.state.idForAdd).then((value) => {
            value.text().then((value) => {
                let JS = JSON.parse(value);
                this.setState({
                    idForOpened: true,
                    animeList: JS,
                    backdrop: true,
                });
            });
        }).catch((error) => {
            this.setState({
                backdrop: false,
            });
        });
    }
    closeIdForOpened = () => {
        this.setState({
            idForOpened: false,
            animeList: [],
            backdrop: false,
        });
    }
    bannedUsers = (user) => {
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
        window.main.switchLoading();
        let data = JSON.parse(localStorage.getItem("loggedData"));
        fetch('https://app.sanime.net/function/h10.php?page=bannedUserHere', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `password=${encodeURIComponent(data.password)}&email=${encodeURIComponent(data.email)}&userId=${encodeURIComponent(user.userAddress)}`
        }).then((response) => {
            response.text().then((va) => {
                window.main.showMessage(va,"تنبيه","حسنا","",true);
                this.prepare();
            });
        }).catch((err) => {
            window.main.showMessage("توجد مشكلة حاول مجددا","تنبيه","حسنا","",true);
            this.prepare();
        });
    }
    deletePost = () => {
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
        if (localStorage.getItem("logged") !== null) {
            let data = JSON.parse(localStorage.getItem("loggedData"));
            window.main.switchLoading();
            fetch('https://app.sanime.net/function/h10.php?page=deletePost', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    password: data.password,
                    email: data.email,
                    userId: data.id,
                    id: this.state.menuId
                })
            }).then((response) => {
                response.json().then((va) => {
                    if (va.status === 1) {
                        window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                    } else {
                        window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                    }
                    this.prepare();
                });
            }).catch((err) => {
                window.main.showMessage("توجد مشكلة حاول مجددا","تنبيه","حسنا","",true);
                this.prepare();
            });
        } else {
            window.main.showMessage("توجد مشكلة حاول مجددا","تنبيه","حسنا","",true);
            this.prepare();
        }
    }
    closeMenu = () => {
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
    }
    menuClicked = (event) => {
        this.setState({
            anchorEl: event.currentTarget,
            menuOpen: true,
            menuId: event.currentTarget.id
        });
    }
    changedComment = (value) => {
        this.setState({
            commentString: value.target.value,
            postComment: {
                post: value.target.value,
                id: this.state.postComment.id
            },
        });
    }
    goBack = () => {
        window.home.setState({
           value: 0
        });
    }
    checkTheme = () => {
        if (localStorage.getItem("theme") !== null) {
            return localStorage.getItem("theme").includes("true");
        } else {
            return true
        }
    }
    prepare = () => {
        setTimeout(() => {
            fetch('https://app.sanime.net/function/h10.php?page=getPost').then((response) => {
                response.text().then((va) => {
                    const list = JSON.parse(va);
                    this.setState({
                        loading: false,
                        data: list["list"],
                        story: list["story"],
                        bannedList: list["banned"]
                    });
                    if (localStorage.getItem("userAddress") != null) {
                        if (list["banned"].includes(localStorage.getItem("userAddress"))) {
                            window.main.showMessage("انت محظور","تنبيه","حسنا","",true);
                            window.home.setState({
                               value: 0
                            });
                        }
                    }
                });
                window.main.setState({
                    loading:false
                });
            }).catch((err) => {
                window.main.setState({
                    loading:false
                });
            });
            if (localStorage.getItem("logged") !== null) {
                let data = JSON.parse(localStorage.getItem("loggedData"));
                this.setState({
                    userData: {
                        userimage: data.image,
                        userId: data.id,
                        admin: data.isAdmin.toString().includes("true")
                    }
                });
            }
        },100);
        setTimeout(() => {
            if (document.getElementById("onlineScript") != null) {
                document.getElementById("onlineScript").remove();
            }
            let onlineScript = document.createElement('script');
            onlineScript.src = 'https://app.sanime.net/online.js?time'+ new Date().getTime();
            onlineScript.id = "onlineScript";
            onlineScript.async = true;
            onlineScript.onload = function() {
                window.community.removeBanned()
            };
            //document.head.appendChild(onlineScript);
        },500);
    }
    removeBanned = () => {
        for (let i = 0; i < window.community.state.data.length; i++) {
            // eslint-disable-next-line no-undef
            if (bannedUser != null) {
                // eslint-disable-next-line no-undef
                if (bannedUser.includes(community.state.data[i].userAddress)) {
                    // eslint-disable-next-line no-undef
                    community.state.data.splice(i, 1);
                }
            }
        }
        this.setState({
            // eslint-disable-next-line no-undef
            data: window.community.state.data
        });
    }
    changeFire = (index) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.data[index].hasFire = !this.state.data[index].hasFire;
        const newValue = this.state.data;
        this.setState({
            data: newValue
        });
    }
    showAds = () => {
        //Android.code("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");
    }
    sendPost = () => {
        if (localStorage.getItem("logged") !== null) {
            let data = JSON.parse(localStorage.getItem("loggedData"));
            let androids = window.main.android();
            const formData = new URLSearchParams();
            formData.append('email', data.email);
            formData.append('password', data.password);
            formData.append("deviceId",window.main.getSnoAnimeId())
            formData.append('item', btoa(unescape(encodeURIComponent(JSON.stringify(this.state.postItem)))));
            formData.append('android', androids);
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formData

            };
            this.setState({
                addPost: false,
                postItem: {
                    post: "",
                    hasFire: false,
                    hasAnime: false,
                    hasImage: "",
                    anime: [],
                    youtube: "",
                    userAddress: window.main.getSnoAnimeId()
                },
            });
            window.main.switchLoading();
            fetch('https://app.sanime.net/function/h10.php?page=sendPost', requestOptions).then((response) => {
                response.json().then((va) => {
                    if (va.status === 1) {
                        //window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                        if (!window.main.checkLoggedAndPremium()) {
                            if (window.main.android()) {
                                window.main.openFull();
                            } else {
                                if (window.main.ios()) {
                                    this.showFull();
                                }
                            }
                        }
                    } else {
                        window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                    }
                    this.prepare();
                });
            }).catch((err) => {
                window.main.showMessage("توجد مشكلة حاول مجددا","تنبيه","حسنا","",true);
                this.prepare();
            });
        } else {
            window.main.showMessage("يجب عليك تسجيل الدخول للنشر","تنبيه","حسنا","",true);
        }
    }
    restartPage = () => {
        this.setState({
            loading: true,
            error: false
        });
        setTimeout(()=> {
            this.prepare();
        },500);
    }
    closeAdd = () => {
        this.setState({
            addPost: false,
        })
    }
    openAdd = () => {
        if (localStorage.getItem("logged") !== null) {
            this.setState({
                addPost: true,
            });
        } else {
            window.main.showMessage("يجب عليك تسجيل الدخول للنشر","تنبيه","حسنا","",true);
        }
        this.epMenuClose();
    }
    IdForAddChanged = (value) => {
        this.setState({
            idForAdd: value.target.value,
        });
    }
    closeIdForAdd = () => {
        this.setState({
            idForAddOpen: false,
            backdrop: false,
            idForAdd: "",
        });
    }
    openIdForAdd = () => {
        this.setState({
            idForAddOpen: true,
        });
    }
    IdForAdd = (id) => {
        let newData = JSON.parse('{}');
        newData.id = id;
        if (!this.state.postItem.anime.some(item => item.id === newData.id)) {
            this.state.postItem.anime.push(newData);
            const newValue = this.state.postItem;
            this.setState({
                postItem: newValue,
                idForAdd: '',
            });
            this.closeIdForAdd();
            this.closeIdForOpened();
        } else {
            this.closeIdForAdd();
            this.closeIdForOpened();
        }
    }
    changedPost = (value) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.postItem.post = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }
    changedBackground = (value) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.postItem.background = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }
    changedPostStory = (value) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.postStory.post = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postStory: newValue
        });
    }
    changedImageStory = (value) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.postStory.hasImage = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postStory: newValue
        });
    }
    changedYoutube = (value) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.postItem.youtube = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }
    changedImage = (value) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.postItem.hasImage = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }
    hasFireChanged = (value) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.postItem.hasFire = value.target.checked;
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }
    deleteAnimeId = (data) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.postItem.anime = this.state.postItem.anime.filter((chip) => chip.id !== data.id);
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }
    showComment = (item) => {
        window.main.switchLoading();
        this.setState({
            postComment: {
                post: "",
                id: this.state.data[item].id
            },
        });
        this.prepare();
        fetch('https://app.sanime.net/function/h10.php?page=getCmd&id=' + this.state.data[item].id).then((response) => {
            response.text().then((va) => {
                if (va.includes('Post Deleted')) {
                    window.main.showMessage("المنشور محذوف","تنبيه","حسنا","",true);
                } else {
                    this.setState({
                        comment: true,
                        commentData: JSON.parse(va),
                        commentLoading: false,
                    });
                    setTimeout(() => {
                        if (this.checkTheme()) {
                            document.getElementById("addCmd").setAttribute("style","color: white;");
                        } else {
                            document.getElementById("addCmd").setAttribute("style","color: black;");
                        }
                    },100);
                }
                window.main.switchLoading();
            });
        }).catch(() => {
            window.main.switchLoading();
            window.main.showMessage("توجد مشكلة حاول مجددا","تنبيه","حسنا","",true);
        });
    }
    closeComment = () => {
        this.setState({
            comment: false,
            commentData: [],
            commentLoading: true,
        });
        window.main.setState({
            loading : false
        });
    }
    sendCmd = () => {
        if (this.state.commentString.length < 2) {
            alert("يجب على تعليقك أن يكون حرفين أو أكثر");
        } else {
            if (localStorage.getItem("logged") !== null) {
                window.main.switchLoading();
                this.setState({
                    comment: false,
                    commentData: [],
                    commentLoading: false,
                });
                let data = JSON.parse(localStorage.getItem("loggedData"));
                const formData = new URLSearchParams();
                formData.append('email', data.email);
                formData.append('password', data.password);
                formData.append('item', btoa(unescape(encodeURIComponent(JSON.stringify(this.state.postComment)))));

                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: formData
                };

                fetch('https://app.sanime.net/function/h10.php?page=addCmdPost', requestOptions).then((response) => {
                    response.json().then((va) => {
                        if (va.status === 1) {
                            window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                            this.setState({
                                comment: true,
                                commentData: va.list,
                                commentLoading: false,
                                commentString: ""
                            });
                        } else {
                            this.setState({
                                comment: false,
                                commentLoading: false,
                                commentString: ""
                            });
                            window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                        }
                        this.prepare();
                    });
                }).catch(() => {
                    this.setState({
                        comment: false,
                        commentLoading: false,
                        commentString: ""
                    });
                    window.main.showMessage("توجد مشكلة حاول مجددا","تنبيه","حسنا","",true);
                    this.prepare();
                });
            } else {
                this.setState({
                    comment: false,
                    commentData: [],
                    commentLoading: false,
                });
                window.main.showMessage("يجب عليك تسجيل الدخول لأضافة تعليق","تنبيه","حسنا","",true);
            }
        }
    }
    isMe = (item) => {
        if (this.state.userData.admin) {
            return true;
        } else {
            return this.state.userData.userId + this.state.userData.userimage === item.userId + item.userimage;
        }
    }
    isAdmin = () => {
        if (localStorage.getItem("logged") !== null) {
            let data = JSON.parse(localStorage.getItem("loggedData"));
            return !!data.isAdmin.includes("true");
        } else {
            return false;
        }
    }

    render() {
        if (this.state.loading) {
            return <Container style={{placeContent: 'center',textAlign: 'center',height: '100%'}}>
                <div style={{height: '350px'}} />
                <GifLoader size={55} />
                <div/>
            </Container>
        } else {
            return <Box style={{marginTop: '0px',marginBottom: '7px'}} height={'100%'}>
                {this.state.data.length === 0 ? <CenterEmpty/> : <Box/>}
                <Container sx={{paddingLeft: "0px",paddingRight: "0px"}}>
                    <List style={{paddingTop: "0px"}}>
                        {
                            this.state.data.map( (item, index) =>
                                <ListItem style={{paddingLeft: "7px", paddingRight: "7px"}} key={item.id}>
                                    <Card sx={{ width: "100%",borderRadius: "8px",background: "transparent",position: "relative" }} className={this.checkTheme() ? "linedShadowD" : "linedShadowL"}>
                                        {
                                            item.background && (
                                                <iframe
                                                    frameBorder={"true"}
                                                    allowTransparency
                                                    seamless
                                                    scrolling="no"
                                                    src={item.background}
                                                    style={{ position: "absolute", width: "100%", height: "100%", opacity: "0.7" }}
                                                />
                                            )
                                        }
                                        <Box style={{position: "relative"}}>
                                            <CardHeader
                                                avatar={
                                                    item.admin.toString().includes("true") ? <Tooltip title="الأدارة">
                                                        <Avatar aria-label="recipe" src={item.userimage}/>
                                                    </Tooltip> : <Avatar aria-label="recipe" src={item.userimage}/>
                                                }
                                                action={
                                                    this.isMe(item) ? <IconButton aria-label="settings" id={item.id} onClick={this.menuClicked}>
                                                        <MoreVertOutlined />
                                                    </IconButton> : <Box/>
                                                }
                                                title={item.hasPremium.toString() !== "1" ? <Box>
                                            <span style={this.checkTheme() ? {color: "white",display: "inline-flex"} : {color: "black",display: "inline-flex"}}>
                                                {item.username}
                                                <div style={{marginLeft: "4px"}}>
                                                        {
                                                            item.admin.toString().includes("true") ? <CheckCircleOutline style={{fontSize: "large",color: "#00b2ff"}}/> : <div/>
                                                        }
                                                </div>
                                            </span>
                                                </Box> : <Box>
                                            <span style={{color: "gold", textShadow: '0px 0px 5px #ffeb3b',display: "inline-flex"}}>
                                                {item.username}
                                                <div style={{marginLeft: "4px"}}>
                                                        {
                                                            item.admin.toString().includes("true") ? <CheckCircle style={{fontSize: "large",color: "#00b2ff"}}/> : <div/>
                                                        }
                                                </div>
                                            </span>
                                                </Box>}
                                                subheader={<Typography style={{fontSize: "14px",opacity: "0.8",display: "inline-flex"}}>
                                                    {item.time}
                                                </Typography>}
                                            />
                                            {this.state.menuId === item.id ? <Menu
                                                id={item.id}
                                                anchorEl={this.state.anchorEl}
                                                open={this.state.menuOpen}
                                                onClose={this.closeMenu}
                                                MenuListProps={{
                                                    'aria-labelledby': item.id,
                                                }}
                                                TransitionComponent={Fade}
                                            >
                                                <MenuItem onClick={this.deletePost}>
                                                    <ListItemIcon>
                                                        <DeleteOutline fontSize="small" />
                                                    </ListItemIcon>
                                                    <ListItemText>حذف</ListItemText>
                                                </MenuItem>
                                                {
                                                    this.isAdmin() ? <MenuItem onClick={this.bannedUsers.bind(this,item)}>
                                                        <ListItemIcon>
                                                            <RemoveCircle fontSize="small" />
                                                        </ListItemIcon>
                                                        <ListItemText>حظر</ListItemText>
                                                    </MenuItem> : <Box/>
                                                }
                                            </Menu> : <Box/> }
                                            <CardContent style={{textAlign: "unset",paddingTop: "1px",paddingBottom: "3px"}} dir="auto">
                                                {
                                                    item.hasFire ? <Button style={{width: "100%",color: "#ff0000"}} onClick={this.changeFire.bind(this,index)}>المنشور يحتوي على حرق (اضغط للمشاهدة)</Button> :
                                                        <Typography style={{width: "100%",textAlign: "initial",whiteSpace: "pre-line"}} dir="auto" aria-multiline={true}>{item.post}</Typography>
                                                }
                                            </CardContent>
                                            {
                                                item.youtube.length === 0 ? <Box/> : <List>
                                                    <ListItem component="div">
                                                        <Container disableGutters>
                                                            <Card style={{alignItems: "center"}}>
                                                                <div style={{borderRadius: '10px',overflow: 'hidden',width: "100%",display: "flex", height: "fit-content"}}>
                                                                    <iframe title={"youtube"} style={{width: "100%"}} height="230" src={item.youtube} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
                                                                </div>
                                                            </Card>
                                                        </Container>
                                                    </ListItem>
                                                </List>
                                            }
                                            {
                                                item.hasImage.length === 0 ? <Box/> : <CardMedia
                                                    component="img"
                                                    image={item.hasImage}
                                                    onError={(event) => event.target.style.display = 'none'}
                                                    onLoad={(event) => {
                                                        event.target.style.display = 'inline-block';
                                                    }}
                                                    alt={item.username}
                                                />
                                            }
                                            <ListItem component="div" style={{padding: '0px'}}>
                                                <Container disableGutters>
                                                    <div className="scrollmenu" style={this.checkTheme() ? {backgroundColor: '#2d3b46',borderRadius: "8px",margin: "6px"} : {backgroundColor: '#f8f6f6',borderRadius: "8px",margin: "6px"}}>
                                                        {item.anime.map((step, index) => (
                                                            <div key={step.id}>
                                                                <Card style={{margin: "6px"}} sx={{ height: 200, width: 112 }} >
                                                                    <CardActionArea onClick={window.main.goLink.bind(this,'/info?id='+step.id)}>
                                                                        <CardMedia
                                                                            component="img"
                                                                            height="175"
                                                                            image={step.image}
                                                                            alt={step.name}
                                                                        />
                                                                        <Divider sx={{height: 1.2}} color={'#00b2ff'}/>
                                                                        <Stack style={{paddingLeft: '4px',paddingBottom: '3px',paddingTop: '1px'}} spacing={0}>
                                                                            <Typography style={{textOverflow: "ellipsis",overflow: "hidden",fontSize: '14px',whiteSpace: "nowrap"}}>{step.name}</Typography>
                                                                        </Stack>
                                                                    </CardActionArea>
                                                                </Card>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Container>
                                            </ListItem>
                                            <CardActions disableSpacing sx={{justifyContent: "space-between"}}>
                                                <Button onClick={this.showComment.bind(this,index)} startIcon={<CommentOutlined />}>
                                                    {item.commant.length.toString()}
                                                </Button>
                                                <Tooltip title={"معرف المستخدم"}>
                                            <span style={this.checkTheme() ? {color: "white", opacity: "0.5"} : {color: "black",opacity: "0.5"} }>
                                            {item.userId}#
                                        </span>
                                                </Tooltip>
                                            </CardActions>
                                        </Box>
                                    </Card>
                                </ListItem>
                            )
                        }
                    </List>
                </Container>
                <Dialog open={this.state.idForAddOpen} onClose={this.closeIdForAdd}>
                    <List style={this.state.isDark ? {backgroundColor: "#252e39"} : {backgroundColor: "#ffffff"}}>
                        <ListItem style={{padding:"0px"}}>
                            <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                <InputLabel style={this.state.isDark ? {color: 'white'} : {color: 'black'}}>كتابة أسم الأنمي</InputLabel>
                                <OutlinedInput
                                    style={this.state.isDark ? {color: 'white'} : {color: 'black'}}
                                    id="searchItem"
                                    type={'text'}
                                    value={this.state.idForAdd}
                                    onChange={this.IdForAddChanged}
                                    onClick={() => {
                                        setTimeout(() => {
                                            $("html").animate({ scrollTop: -10000 }, 500);
                                            $("body").animate({ scrollTop: -10000 }, 500);
                                        },200);
                                    }}
                                    label="كتابة أسم الأنمي"
                                />
                            </FormControl>
                        </ListItem>
                        <ListItem style={{padding:"0px"}}>
                            <ListItem onClick={this.openIdForOpened} button style={{margin: "7px", borderRadius: "8px",backgroundColor: "#2196f3", textAlign: "center",placeContent: "center"}}>
                                <Typography style={{fontFamily: "'Changa'",color: 'white'}}>
                                    بحث
                                </Typography>
                            </ListItem>
                        </ListItem>
                    </List>
                </Dialog>
                <Dialog open={this.state.idForOpened} onClose={this.closeIdForOpened}>
                    <List>
                        {this.state.animeList.map((item) => <ListItem key={item.id} onClick={this.IdForAdd.bind(this,item.id)}>
                            <ListItemAvatar>
                                <Avatar src={item.image}/>
                            </ListItemAvatar>
                            <ListItemText primary={item.name} />
                        </ListItem>)}
                    </List>
                </Dialog>
                <Dialog
                    fullScreen
                    onClose={() => this.closeAdd()}
                    open={this.state.addPost}
                >
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={this.state.backdrop}>
                        <GifLoader size={55} />
                    </Backdrop>
                    <Box style={{background: this.checkTheme() ? "#182128" : "#efeeee"}}>
                        <AppBar position="static" elevation={0} color={"background"} enableColorOnDark>
                            <Toolbar variant="dense" sx={{paddingLeft: "9px",paddingRight:"9px"}}>
                                <IconButton
                                    onClick={this.closeAdd}
                                    size="medium"
                                    edge="start"
                                    color="inherit"
                                    aria-label="back"
                                    sx={{ marginRight: "0px" }}
                                >
                                    <ArrowBack />
                                </IconButton>
                                <ListItem sx={{padding: "0px"}}>
                                    <ListItemText primary="انشاء منشور" secondary={""} />
                                </ListItem>
                            </Toolbar>
                        </AppBar>
                    </Box>
                    <Box style={{background: this.checkTheme() ? "#182128" : "#efeeee",flexGrow: 1}}>
                        <List style={{margin: "7px", background: this.checkTheme() ? "#182128" : "#efeeee"}}>
                            <ListItem style={{padding:"0px"}}>
                                <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                    <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>محتوى المنشور</InputLabel>
                                    <OutlinedInput
                                        style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                        id="searchItem"
                                        type={'text'}
                                        value={this.state.postItem.post}
                                        multiline={true}
                                        maxRows={5}
                                        dir="auto"
                                        onChange={this.changedPost}
                                        onClick={() => {
                                            setTimeout(() => {
                                                $("html").animate({ scrollTop: -10000 }, 500);
                                                $("body").animate({ scrollTop: -10000 }, 500);
                                            },200);
                                        }}
                                        label="محتوى المنشور"
                                    />
                                </FormControl>
                            </ListItem>
                            <ListItem style={{padding:"0px"}}>
                                <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                    <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>رابط يوتيوب (غير مطلوب)</InputLabel>
                                    <OutlinedInput
                                        style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                        type={'text'}
                                        multiline={true}
                                        maxRows={2}
                                        dir="auto"
                                        id="addYoutube"
                                        value={this.state.postItem.youtube}
                                        onClick={() => {
                                            setTimeout(() => {
                                                $("html").animate({ scrollTop: -10000 }, 500);
                                                $("body").animate({ scrollTop: -10000 }, 500);
                                            },200);
                                        }}
                                        onChange={this.changedYoutube}
                                        label="رابط يوتيوب (غير مطلوب)"
                                    />
                                </FormControl>
                            </ListItem>
                            <ListItem style={{padding:"0px"}}>
                                <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                    <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>رابط صورة (غير مطلوب)</InputLabel>
                                    <OutlinedInput
                                        style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                        type={'text'}
                                        multiline={true}
                                        maxRows={2}
                                        dir="auto"
                                        id="addImage"
                                        value={this.state.postItem.hasImage}
                                        onChange={this.changedImage}
                                        onClick={() => {
                                            setTimeout(() => {
                                                $("html").animate({ scrollTop: -10000 }, 500);
                                                $("body").animate({ scrollTop: -10000 }, 500);
                                            },200);
                                        }}
                                        label="رابط صورة  (غير مطلوب)"
                                    />
                                </FormControl>
                            </ListItem>
                            <ListItem style={{padding:"0px"}}>
                                <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                    <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>رابط خلفية المنشور (بريميوم)</InputLabel>
                                    <OutlinedInput
                                        style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                        type={'text'}
                                        multiline={true}
                                        maxRows={2}
                                        dir="auto"
                                        id="addBackground"
                                        value={this.state.postItem.background}
                                        onChange={this.changedBackground}
                                        onClick={() => {
                                            setTimeout(() => {
                                                $("html").animate({ scrollTop: -10000 }, 500);
                                                $("body").animate({ scrollTop: -10000 }, 500);
                                            },200);
                                        }}
                                        label="رابط خلفية المنشور (بريميوم)"
                                    />
                                </FormControl>
                            </ListItem>
                            <ListItem style={{padding: "0px"}}>
                                <Paper
                                    sx={{
                                        background: this.checkTheme() ? "#182128" : "#efeeee",
                                        display: 'flex',
                                        justifyContent: 'center',
                                        flexWrap: 'wrap',
                                        listStyle: 'none',
                                        p: 0.5,
                                        m: 0,
                                        boxShadow: "unset"
                                    }}
                                    component="ul"
                                >
                                    {this.state.postItem.anime.map((data, index) => {
                                        let icon;
                                        icon = <TagOutlined style={this.checkTheme() ? {color: 'white'} : {color: 'black'}} />;
                                        return (
                                            <ListItemNew key={data.id}>
                                                <Chip
                                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                                    icon={icon}
                                                    deleteIcon={<DeleteOutline style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}/>}
                                                    label={"رقم الأنمي : "+index.toString()}
                                                    onDelete={this.deleteAnimeId.bind(this,data)}
                                                />
                                            </ListItemNew>
                                        );
                                    })}
                                    {this.state.postItem.anime.length < 5 ? <ListItemNew key={'addAnime'}>
                                        {
                                            this.state.postItem.anime.length === 0 ? <Chip clickable label={"أضف معرف أنمي (غير مطلوب)"} icon={<AddCircleOutline style={this.checkTheme() ? {color: 'white'} : {color: 'black'}} />} onClick={this.openIdForAdd} style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}/> : <Chip clickable label={'أضافة'} icon={<AddCircleOutline style={this.checkTheme() ? {color: 'white'} : {color: 'black'}} />} onClick={this.openIdForAdd} style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}/>
                                        }
                                    </ListItemNew> : <Box/>}
                                </Paper>
                            </ListItem>
                            <ListItem>
                                <FormControlLabel control={<Switch checked={this.state.postItem.hasFire} onChange={this.hasFireChanged} />} label="يحتوي على حرق" />
                            </ListItem>
                            <ListItem style={{padding:"0px"}}>
                                <ListItem onClick={this.sendPost} button style={{margin: "7px", borderRadius: "8px",backgroundColor: "#2196f3", textAlign: "center",placeContent: "center"}}>
                                    <Typography style={{fontFamily: "'Changa'",color: 'white'}}>
                                        نشر
                                    </Typography>
                                </ListItem>
                            </ListItem>
                        </List>
                    </Box>
                </Dialog>
                <BottomSheet
                    onRequestClose={() => this.closeStory()}
                    open={this.state.bottomStory}
                >
                    <List style={this.checkTheme() ? {backgroundColor: "#252e39"} : {backgroundColor: "#ffffff"}}>
                        <ListItem style={{padding:"0px"}}>
                            <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>محتوى المنشور</InputLabel>
                                <OutlinedInput
                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                    id="searchItem"
                                    type={'text'}
                                    value={this.state.postStory.post}
                                    multiline={true}
                                    maxRows={5}
                                    dir="auto"
                                    onChange={this.changedPostStory}
                                    onClick={() => {
                                        setTimeout(() => {
                                            $("html").animate({ scrollTop: -10000 }, 500);
                                            $("body").animate({ scrollTop: -10000 }, 500);
                                        },200);
                                    }}
                                    label="محتوى المنشور"
                                />
                            </FormControl>
                        </ListItem>
                        <ListItem style={{padding:"0px"}}>
                            <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>رابط صورة</InputLabel>
                                <OutlinedInput
                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                    type={'text'}
                                    multiline={true}
                                    maxRows={2}
                                    dir="auto"
                                    id="addImage"
                                    value={this.state.postStory.hasImage}
                                    onClick={() => {
                                        setTimeout(() => {
                                            $("html").animate({ scrollTop: -10000 }, 500);
                                            $("body").animate({ scrollTop: -10000 }, 500);
                                        },200);
                                    }}
                                    onChange={this.changedImageStory}
                                    label="رابط صورة"
                                />
                            </FormControl>
                        </ListItem>
                        <ListItem style={{padding:"0px"}}>
                            <ListItem onClick={this.sendPostStory} button style={{margin: "7px", borderRadius: "8px",backgroundColor: "#2196f3", textAlign: "center",placeContent: "center"}}>
                                <Typography style={{fontFamily: "'Changa'",color: 'white'}}>
                                    نشر
                                </Typography>
                            </ListItem>
                        </ListItem>
                    </List>
                </BottomSheet>
                <Dialog
                    fullScreen={true}
                    onClose={this.closeComment}
                    open={this.state.comment}
                >
                    <Box sx={{ flexGrow: 1 }}>
                        <AppBar position="static" elevation={0} color={"background"} enableColorOnDark>
                            <Toolbar variant="dense" sx={{paddingLeft: "9px",paddingRight:"9px"}}>
                                <IconButton
                                    onClick={this.closeComment}
                                    size="medium"
                                    edge="start"
                                    color="inherit"
                                    aria-label="back"
                                    sx={{ marginRight: "0px" }}
                                >
                                    <ArrowBack />
                                </IconButton>
                                <ListItem sx={{padding: "0px"}}>
                                    <ListItemText primary="التعليقات" secondary={""} />
                                </ListItem>
                            </Toolbar>
                        </AppBar>
                    </Box>
                    <List style={{width: "100%"}} sx={{backgroundColor: "background.paper"}}>
                        <ListItem style={{padding: "3px"}}>
                            <FormControl fullWidth focused color={"primary"} style={this.checkTheme() ? {backgroundColor: '#2c3846'} : {backgroundColor: '#f8f6f6'}}>
                                <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>أكتب هنا</InputLabel>
                                <OutlinedInput
                                    dir={'auto'}
                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                    id="addCmd"
                                    type={'text'}
                                    value={this.state.commentString}
                                    onChange={this.changedComment}
                                    onClick={() => {
                                        setTimeout(() => {
                                            $("html").animate({ scrollTop: -10000 }, 500);
                                            $("body").animate({ scrollTop: -10000 }, 500);
                                        },200);
                                    }}
                                    label="أكتب هنا"
                                />
                            </FormControl>
                            <ListItemAvatar style={{minWidth: "unset",marginLeft: "4px",marginRight: "4px"}}>
                                <IconButton onClick={this.sendCmd} style={this.checkTheme() ? {backgroundColor: '#2c3846'} : {backgroundColor: '#ebebeb'}}>
                                    <SendOutlined />
                                </IconButton>
                            </ListItemAvatar>
                        </ListItem>
                    </List>
                    <Box style={{background: this.checkTheme() ? "#182128" : "#efeeee"}} height={'100%'}>
                        {this.state.commentLoading ? <CenterLoading/> : <List style={{padding: "0", background: this.checkTheme() ? "#182128" : "#efeeee"}}>
                            {this.state.commentData.length === 0 ? <CenterEmpty/> : this.state.commentData.map(item =>
                                <ListItem style={{paddingLeft: "7px", paddingRight: "7px"}} key={item.id}>
                                    <Card sx={{ width: "100%",borderRadius: "8px",backgroundColor: "transparent" }} elevation={0} className={this.checkTheme() ? "linedShadowD" : "linedShadowL"}>
                                        <CardHeader
                                            avatar={
                                                item.admin.toString().includes("true") ? <Tooltip title="الأدارة">
                                                    <Avatar aria-label="recipe" src={item.userimage}/>
                                                </Tooltip> : <Avatar aria-label="recipe" src={item.userimage}/>
                                            }
                                            title={item.hasPremium !== "1" ? item.username : <Box>
                                            <span style={{color: "gold", textShadow: '0px 0px 5px #ffeb3b'}}>
                                                {item.username}
                                            </span>
                                            </Box>}
                                            subheader={<Typography style={{fontSize: "14px",opacity: "0.8"}}>{item.time}</Typography>}
                                        />
                                        <CardContent style={{textAlign: "unset"}} dir="auto">
                                            <Typography style={{width: "100%",textAlign: "initial",whiteSpace: "pre-line"}} dir="auto" aria-multiline={true}>
                                                {item.post}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </ListItem>
                            )}
                        </List> }
                    </Box>
                </Dialog>
            </Box>
        }
    }
}